import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ImobiliariaAtualizarRequest, ImobiliariaCheckoutRequest, ImobiliariaCheckoutResponse, ImobiliariaDetalhadaResponse, ImobiliariaForAutocompleteResponse, ImobiliariaRequest, ImobiliariaResponse } from 'app/shared/models/ei-models';
import { BaseService } from '../../core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImobiliariaService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Imobiliaria/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  listarImobiliarias(filter: ImobiliariaRequest, loader = true): Observable<Array<ImobiliariaResponse>> {
    return this.httpClient.post<Array<ImobiliariaResponse>>
      (this.controllerEndpoint.concat('ListarImobiliarias'), filter, { headers: this.getHeader(loader) });
  }

  getAllForAutocomplete(loader = true): Observable<Array<ImobiliariaForAutocompleteResponse>> {
    return this.httpClient.get<Array<ImobiliariaForAutocompleteResponse>>
      (this.controllerEndpoint.concat('GetAllForAutocomplete'), { headers: this.getHeader(loader) });
  }

  criarImobiliaria(request: ImobiliariaCheckoutRequest, loader = true): Observable<ImobiliariaCheckoutResponse> {
    return this.httpClient.post<ImobiliariaCheckoutResponse>(
      this.controllerEndpoint.concat('Criar'),
      request,
      { headers: this.getHeader(loader) }
    );
  }

  /**
   * Obtém os dados detalhados da imobiliária do usuário logado
   */
  getMinhaImobiliaria(loader = true): Observable<ImobiliariaDetalhadaResponse> {
    return this.httpClient.get<any>(
      this.controllerEndpoint.concat('MinhaImobiliaria'),
      { headers: this.getHeader(loader) }
    ).pipe(
      map(response => new ImobiliariaDetalhadaResponse(response))
    );
  }

  /**
   * Atualiza os dados da imobiliária do usuário logado (ADM_IMOBILIARIA)
   */
  atualizarImobiliaria(request: ImobiliariaAtualizarRequest, loader = true): Observable<void> {
    return this.httpClient.put<void>(
      this.controllerEndpoint.concat('Atualizar'),
      request,
      { headers: this.getHeader(loader) }
    );
  }

  /**
   * ADM_SISTEMA: atualiza qualquer imobiliária pelo ID. Não permite trocar plano.
   */
  atualizarImobiliariaPorId(id: number, request: ImobiliariaAtualizarRequest, loader = true): Observable<void> {
    return this.httpClient.put<void>(
      this.controllerEndpoint.concat('Atualizar/', id.toString()),
      request,
      { headers: this.getHeader(loader) }
    );
  }

  /**
   * ADM_SISTEMA: retorna os dados detalhados de qualquer imobiliária (para edição).
   */
  detalharImobiliaria(id: number, loader = true): Observable<ImobiliariaDetalhadaResponse> {
    return this.httpClient.get<any>(
      this.controllerEndpoint.concat('Detalhar/', id.toString()),
      { headers: this.getHeader(loader) }
    ).pipe(
      map(response => new ImobiliariaDetalhadaResponse(response))
    );
  }

  /**
   * Obtém a quantidade de usuários ativos na imobiliária
   */
  getUsuariosAtivos(loader = true): Observable<number> {
    return this.httpClient.get<number>(
      this.controllerEndpoint.concat('UsuariosAtivos'),
      { headers: this.getHeader(loader) }
    );
  }
}